// extracted by mini-css-extract-plugin
export var actionText = "_pq-4";
export var container = "_pq-0";
export var leftSection = "_pq-1";
export var rightSection = "_pq-2";
export var settingsButton = "_pq-6";
export var settingsIcon = "_pq-7";
export var shortcut = "_pq-5";
export var shortcutGroup = "_pq-3";